<div class="container-fluid p-3">
  <div class="row">
    <div class="mb-4">
      <!-- Header section with buttons and title -->
      <div
        class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-4 flex-wrap">
        <!-- Title aligned to the right on larger screens -->
        <h4 class="m-0 text-md-end text-start text-color fs-24 fg-500">
          {{ 'TEST_MODE.PRACTICE' | translate }}
        </h4>
      </div>

      <!-- Card with data table -->
      <div class="mt-3">
        <app-student-tests [testMode]="'practice'" />
      </div>
    </div>
  </div>
</div>